// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2ypfg","productName":"Table_productName__3Rpa_"};